import React, {PropsWithChildren} from "react";

/**
 * Renders a color-themed frame around its children.
 */
const Frame = ({children}: PropsWithChildren<unknown>) => {
  return (
    <div className="max-w-[27.25rem] w-full rounded-lg bg-green-200 flex gap-2">{children}</div>
  );
};

export default React.memo(Frame);
